<template>
  <f7-page :page-content="false">
    <f7-page-content class="popup-content">
      <f7-navbar title="Select Tags"/>
      <f7-searchbar ref="input"
                    @input="text = $event.target.value"
                    :value="text"
                    clear-button
                    :disable-button="false"
                    placeholder="Start typing a tag"
                    class="main-input"
      />
      <div class="available-tags">
        <f7-list>
          <f7-list-item v-for="tag in filteredTags"
                        :key="tag.name"
                        :title="tag.name"
                        @click="tagPress(tag)"
          >
            <f7-icon slot="after" material="add" color="gray"/>
          </f7-list-item>
        </f7-list>
      </div>
      <div class="used-tags" v-if="usedTags.length">
        <tag-chip v-for="tag in usedTags"
                  :tag="tag"
                  :key="tag.name"
                  @click="untagPress(tag)"
                  added
                  style="margin-right: 0.2em;"
        />
      </div>
      <f7-segmented class="bottom-buttons" raised>
        <f7-button large fill @click="$emit('cancel')" color="pink" text="Cancel"/>
        <f7-button large fill @click="$emit('confirm')" text="Use these tags"/>
      </f7-segmented>
    </f7-page-content>
  </f7-page>
</template>

<script>
  import {List, Set} from 'immutable'
  import fuzzysort from 'fuzzysort'
  import TagChip from '@/components/TagChip'

  function scoreTag (tag) {
    if (tag.pseudo) {
      // Basically we're trying to ensure that "real" tags are almost always given priority over pseudo tags.
      return -tag.usage / 10
    }
    return -tag.usage
    // both return negative results to invert sort order.
  }

  function sortKey (fuzzyResult) {
    return scoreTag(fuzzyResult.obj) - (fuzzyResult.score / 10)
  }


  export default {
    name: 'TagEntryInner',
    components: {
      TagChip,
    },
    props: {
      value: {
        type: Array,
        default: () => [],
      },
    },
    data () {
      return {
        usedTags: this.value,
        text: '',
      }
    },
    methods: {
      async tagPress (tag) {
        await this.$nextTick()
        this.usedTags = Set.of(...this.usedTags).add(tag).toArray()
        this.text = ''
        this.$refs.input.$el.querySelector('input').focus()
      },
      async untagPress (tag) {
        this.usedTags = Set.of(...this.usedTags).delete(tag).toArray()
        this.$refs.input.$el.querySelector('input').focus()
      },
    },
    computed: {
      availableTags () {
        return Set.of(...this.$store.state.tags.tags)
      },
      unusedTags () {
        return this.availableTags.subtract(this.usedTags)
      },
      usedInOrder () {
        return List.of(...this.usedTags).sortBy(t => this.usedTags.indexOf(t))
      },
      filteredTags () {
        let tags = this.unusedTags

        if (!this.text) {
          return List.of(...tags).sortBy(t => scoreTag(t))
        }

        if (!tags.map(tag => tag.name).includes(this.text)) {
          tags = tags.add({ name: this.text, usage: 0, pseudo: true })
        }
        const filteredTags = fuzzysort.go(this.text, tags.toArray(), { key: 'name' })
        return List.of(...filteredTags)
          .sortBy(sortKey)
          .map(result => result.obj)

      },
    },
    watch: {
      usedTags () {
        this.$emit('input', this.usedTags)
      },
      value () {
        this.usedTags = this.value
      },
    },
  }
</script>

<style lang="scss" scoped>
  .popup-content {
    display: flex;
    flex-direction: column;
    height: 100%;

    .navbar {
      min-height: 2em;
    }

    .available-tags {
      flex-grow: 1;
      overflow-y: auto;

      .device-desktop & {
        overflow-y: hidden;
      }

      .list {
        margin: 0;
      }

      li {
        cursor: pointer;
      }
    }

    .used-tags {
      padding: 1em;
    }

    .main-input {
      min-height: 2.5em;
    }

    .bottom-buttons {
      // Can't just use padding or the shadow doesn't show
      width: calc(100% - 2em);
      margin: 1em;
    }
  }
</style>
